import type { CSSProperties } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * https://sonner.emilkowal.ski/toaster
 */
const Toaster = ({ style, ...props }: ToasterProps) => {
  return (
    <Sonner
      offset={32}
      richColors
      style={
        {
          '--normal-bg': 'hsl(var(--card))',
          '--normal-border': 'hsl(var(--border))',
          '--normal-text': 'hsl(var(--card-foreground))',
          '--success-bg': 'hsl(var(--success) / 0.7)',
          '--success-border': 'hsl(var(--success) / 0.9)',
          '--success-text': 'hsl(var(--success-foreground))',
          '--error-bg': 'hsl(var(--destructive) / 0.7)',
          '--error-border': 'hsl(var(--destructive) / 0.9)',
          '--error-text': 'hsl(var(--destructive-foreground))',
          '--warning-bg': 'hsl(var(--warning) / 0.7)',
          '--warning-border': 'hsl(var(--warning) / 0.9)',
          '--warning-text': 'hsl(var(--warning-foreground))',
          '--info-bg': 'hsl(var(--primary) / 0.7)',
          '--info-border': 'hsl(var(--primary) / 0.9)',
          '--info-text': 'hsl(var(--primary-foreground))',
          ...style,
        } as CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: 'rounded-3xl border p-4 shadow-md bg-card text-card-foreground border-border',
          title: 'font-regular text-base',
          description: 'font-regular text-sm',
          closeButton: 'bg-card border border-border text-foreground',
        },
      }}
      visibleToasts={5}
      {...props}
    />
  );
};

export { Toaster };
